//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import { Opaque } from '@utils/opaque';

type ClientId = Opaque<number, 'ClientId'>;

function ClientIdFactory(clientId: number) {
  return clientId as ClientId;
}

const ClientId = Object.assign(
  ClientIdFactory,
  {
    fromString(clientId: string) {
      return ClientIdFactory(parseInt(clientId, 10));
    },
  },
);

export default ClientId;
